// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2WvTp","gfeWrapper":"CalendarEvent_gfeWrapper__EtzDp"};